import React from 'react';

import { cashAdvanceFeeTooltipText, currencyString } from '@consumer-frontend/nc-utils';
import { Icon } from '@consumer-frontend/shared-ui';

import { NcCardHeading, NcCardPanel } from '../NcCard';
import { NcLoadingSpinner } from '../NcLoadingSpinner';
import {
  NcPercentageBar,
  NcPercentageBarColorPill,
  PercentageBarSegmentT,
} from '../NcPercentageBar';
import { NcTooltip } from '../NcTooltip';

import '@consumer-bootstrap/netcredit.scss';
// eslint-disable-next-line import/order
import '@consumer-bootstrap/brands/netcredit/draw-request/deposited-amount.scss';

export type NcDepositedAmountPropsT = {
  cashAdvanceFee?: string;
  depositedAmount?: number;
  drawFee?: number;
  isLoading?: boolean;
  requestedAmount?: number;
};
export type NcDepositedAmountT = React.FC<NcDepositedAmountPropsT>;

export const NcDepositedAmount: NcDepositedAmountT = ({
  cashAdvanceFee,
  depositedAmount,
  drawFee,
  isLoading,
  requestedAmount,
}) => {
  const percentageBarSegments: PercentageBarSegmentT[] = [
    {
      color: 'blue',
      title: 'Deposited Amount',
      value: depositedAmount ?? 0,
    },
    {
      color: 'lightBlue',
      title: 'Cash Advance Fee',
      value: drawFee ?? 0,
    },
  ];

  return (
    <NcCardPanel className="nc-deposited-amount">
      <NcCardHeading level={2} className="h4 semi-bold">Deposited Amount</NcCardHeading>

      {isLoading && <NcLoadingSpinner />}

      {!isLoading && (
        <>
          <NcPercentageBar segments={percentageBarSegments} />

          <dl className="deposited-amount-breakdown">
            <div className="deposited-amount-row">
              <dt>Requested Amount:</dt>
              <dd>{currencyString(requestedAmount || 0)}</dd>
            </div>

            <div className="deposited-amount-row">
              <dt>
                <NcPercentageBarColorPill color="lightBlue" />
                <span>Cash Advance Fee ({cashAdvanceFee}):</span>
                <NcTooltip tooltipContent={cashAdvanceFeeTooltipText}>
                  <Icon iconName="info-circle-fill" />
                </NcTooltip>
              </dt>
              <dd>
                {`- ${currencyString(drawFee ?? 0)}`}
              </dd>
            </div>

            <div className="deposited-amount-row deposited-amount-total">
              <dt>
                <NcPercentageBarColorPill color="blue" />
                <span>Total Deposited to You:</span>
              </dt>
              <dd>{currencyString(depositedAmount ?? 0)}</dd>
            </div>
          </dl>
        </>
      )}
    </NcCardPanel>
  );
};
